/**
 * @generated SignedSource<<736fce5695b2fa834422eae198066e55>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedEditorialArticles_refactor_item$data = {
  readonly storyTellingModule: {
    readonly tabs: ReadonlyArray<{
      readonly supplementaryEditorial: {
        readonly articles: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"EditorialModuleArticles_articles">;
        }> | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PdpSharedEditorialArticles_refactor_item";
};
export type PdpSharedEditorialArticles_refactor_item$key = {
  readonly " $data"?: PdpSharedEditorialArticles_refactor_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEditorialArticles_refactor_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEditorialArticles_refactor_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "shortTitles",
          "value": true
        }
      ],
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WordpressArticlesType",
              "kind": "LinkedField",
              "name": "supplementaryEditorial",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WordpressArticleType",
                  "kind": "LinkedField",
                  "name": "articles",
                  "plural": true,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "EditorialModuleArticles_articles"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "storyTellingModule(shortTitles:true)"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "680ae205aa754b4d9e7cae2a5cea431a";

export default node;
